import { render, staticRenderFns } from "./TaskNewDialogEdit.vue?vue&type=template&id=11fe4af4&scoped=true"
import script from "./TaskNewDialogEdit.vue?vue&type=script&lang=js"
export * from "./TaskNewDialogEdit.vue?vue&type=script&lang=js"
import style0 from "./TaskNewDialogEdit.vue?vue&type=style&index=0&id=11fe4af4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11fe4af4",
  null
  
)

export default component.exports